const financialData = [
  {
    month: ["2022", "Jan"],
    totalRevenue: 375344.25,
    projectedRevenue: 400000,
    grossMargin: 0.55220745,
    projectedGrossMargin: null,
    salesAndMarketing: 437506.09,
    projectedSalesAndMarketing: null,
    totalExpenses: 608790.65,
    projectedTotalExpenses: null,
    preMarketingEbitda: 207267.89,
    projectedPreMarketingEbitda: null,
    ebitda: -230238.2,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Feb"],
    totalRevenue: 350652.6,
    projectedRevenue: 400000,
    grossMargin: 0.4469737,
    projectedGrossMargin: null,
    salesAndMarketing: 328297.86,
    projectedSalesAndMarketing: null,
    totalExpenses: 523089.77,
    projectedTotalExpenses: null,
    preMarketingEbitda: 156732.49,
    projectedPreMarketingEbitda: null,
    ebitda: -171565.37,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Mar"],
    totalRevenue: 399967.95,
    projectedRevenue: 400000,
    grossMargin: 0.43483912,
    projectedGrossMargin: null,
    salesAndMarketing: 513041.16,
    projectedSalesAndMarketing: null,
    totalExpenses: 740448.03,
    projectedTotalExpenses: null,
    preMarketingEbitda: 173921.71,
    projectedPreMarketingEbitda: null,
    ebitda: -339119.45,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Apr"],
    totalRevenue: 421113.8,
    projectedRevenue: 400000,
    grossMargin: 0.59451996,
    projectedGrossMargin: null,
    salesAndMarketing: 514452.25,
    projectedSalesAndMarketing: null,
    totalExpenses: 688510.83,
    projectedTotalExpenses: null,
    preMarketingEbitda: 250360.56,
    projectedPreMarketingEbitda: null,
    ebitda: -264091.69,
    projectedEbitda: null,
  },
  {
    month: ["2022", "May"],
    totalRevenue: 437060.66,
    projectedRevenue: 400000,
    grossMargin: 0.55973972,
    projectedGrossMargin: null,
    salesAndMarketing: 343500.96,
    projectedSalesAndMarketing: null,
    totalExpenses: 541608.38,
    projectedTotalExpenses: null,
    preMarketingEbitda: 244640.21,
    projectedPreMarketingEbitda: null,
    ebitda: -98860.75,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Jun"],
    totalRevenue: 461146.41,
    projectedRevenue: 400000,
    grossMargin: 0.50295463,
    projectedGrossMargin: null,
    salesAndMarketing: 320623.21,
    projectedSalesAndMarketing: null,
    totalExpenses: 556096.08,
    projectedTotalExpenses: null,
    preMarketingEbitda: 231935.72,
    projectedPreMarketingEbitda: null,
    ebitda: -88687.49,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Jul"],
    totalRevenue: 502910.95,
    projectedRevenue: 400000,
    grossMargin: 0.67257247,
    projectedGrossMargin: null,
    salesAndMarketing: 353983.7,
    projectedSalesAndMarketing: null,
    totalExpenses: 523841.96,
    projectedTotalExpenses: null,
    preMarketingEbitda: 338244.06,
    projectedPreMarketingEbitda: null,
    ebitda: -15739.64,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Aug"],
    totalRevenue: 538945.3,
    projectedRevenue: 400000,
    grossMargin: 0.62932416,
    projectedGrossMargin: null,
    salesAndMarketing: 380675.42,
    projectedSalesAndMarketing: null,
    totalExpenses: 583853.99,
    projectedTotalExpenses: null,
    preMarketingEbitda: 339171.3,
    projectedPreMarketingEbitda: null,
    ebitda: -41504.12,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Sep"],
    totalRevenue: 574821.13,
    projectedRevenue: 400000,
    grossMargin: 0.63520292,
    projectedGrossMargin: null,
    salesAndMarketing: 502714.43,
    projectedSalesAndMarketing: null,
    totalExpenses: 715312.54,
    projectedTotalExpenses: null,
    preMarketingEbitda: 365128.06,
    projectedPreMarketingEbitda: null,
    ebitda: -137586.37,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Oct"],
    totalRevenue: 597897.49,
    projectedRevenue: 400000,
    grossMargin: 0.70457086,
    projectedGrossMargin: null,
    salesAndMarketing: 615347.78,
    projectedSalesAndMarketing: null,
    totalExpenses: 794833.25,
    projectedTotalExpenses: null,
    preMarketingEbitda: 421261.15,
    projectedPreMarketingEbitda: null,
    ebitda: -194086.63,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Nov"],
    totalRevenue: 708884.88,
    projectedRevenue: 400000,
    grossMargin: 0.65385095,
    projectedGrossMargin: null,
    salesAndMarketing: 1144586,
    projectedSalesAndMarketing: null,
    totalExpenses: 1395357.17,
    projectedTotalExpenses: null,
    preMarketingEbitda: 463505.05,
    projectedPreMarketingEbitda: null,
    ebitda: -681080.95,
    projectedEbitda: null,
  },
  {
    month: ["2022", "Dec"],
    totalRevenue: 924244.24,
    projectedRevenue: 400000,
    grossMargin: 0.66328409,
    projectedGrossMargin: null,
    salesAndMarketing: 1183243.33,
    projectedSalesAndMarketing: null,
    totalExpenses: 1509829.98,
    projectedTotalExpenses: null,
    preMarketingEbitda: 613036.5,
    projectedPreMarketingEbitda: null,
    ebitda: -570206.83,
    projectedEbitda: null,
  },
  {
    month: ["2023", "Jan"],
    totalRevenue: 1061512.82,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.63563632,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1440906.04,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 1853242.89,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 674736.1,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -766169.94,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Feb"],
    totalRevenue: 1068403.37,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.66954098,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1067391.9,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 1443016.31,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 715339.84,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -352052.06,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Mar"],
    totalRevenue: 1250730.54,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.65224188,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1333007.62,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 1798374.49,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 815778.84,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -517228.78,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Apr"],
    totalRevenue: 1382031.3,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.70554431,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1569917.2,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2021277.23,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 975084.32,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -594832.88,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "May"],
    totalRevenue: 1541681.3,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.67808519,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1788465.9,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2333868.91,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1045391.25,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -743074.65,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Jun"],
    totalRevenue: 1686330.23,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.6251876,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1893239.35,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2582948.14,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1054272.75,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -838966.6,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Jul"],
    totalRevenue: 1891553.18,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.64172278,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 2462901.28,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 3200750.17,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1213852.77,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -1249048.51,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Aug"],
    totalRevenue: 2040789.71,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.66925402,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1528609.85,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2274219.07,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1365806.72,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -162803.13,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Sep"],
    totalRevenue: 2085807.31,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.60058566,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1380236.28,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2286798.7,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1252705.96,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -127530.32,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Oct"],
    totalRevenue: 2113073.16,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.6768269,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1607467.11,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2356879.78,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1430184.75,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: -177282.36,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Nov"],
    totalRevenue: 2189861.1,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.6794273,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1479244.75,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2260832.2,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1487851.42,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: 8606.67,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2023", "Dec"],
    totalRevenue: 2298311.42,
    projectedRevenue: 887072.83333333,
    grossMargin: 0.73440144,
    projectedGrossMargin: 0.53300697,
    salesAndMarketing: 1484214.76,
    projectedSalesAndMarketing: 334856.5,
    totalExpenses: 2170069.1,
    projectedTotalExpenses: 493303.41666667,
    preMarketingEbitda: 1687883.22,
    projectedPreMarketingEbitda: 314369.16666667,
    ebitda: 203668.46,
    projectedEbitda: -20487.33333333,
  },
  {
    month: ["2024", "Jan"],
    totalRevenue: 2343039.86,
    projectedRevenue: 907702.75,
    grossMargin: 0.65828641,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1549884.1,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2425607.79,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1542391.29,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: -7492.81,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Feb"],
    totalRevenue: 2235042.49,
    projectedRevenue: 907702.75,
    grossMargin: 0.67673411,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1490790.93,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2287768.44,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1512529.49,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 21738.56,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Mar"],
    totalRevenue: 2482952.72,
    projectedRevenue: 907702.75,
    grossMargin: 0.69051134,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1552007.28,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2390187.66,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1714507.02,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 162499.74,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Apr"],
    totalRevenue: 2469301.14,
    projectedRevenue: 907702.75,
    grossMargin: 0.67733012,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1485401.4,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2356892.16,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1672532.03,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 187130.63,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "May"],
    totalRevenue: 2604888.38,
    projectedRevenue: 907702.75,
    grossMargin: 0.71845533,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1875098.9,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2681086.85,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1871495.95,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: -3602.95,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Jun"],
    totalRevenue: 2589515.82,
    projectedRevenue: 907702.75,
    grossMargin: 0.71422139,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 2247251.19,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 3061993.68,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1849487.59,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: -397763.6,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Jul"],
    totalRevenue: 2705124.13,
    projectedRevenue: 907702.75,
    grossMargin: 0.70986552,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1896465.81,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2754557.53,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1920274.35,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 23808.54,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Aug"],
    totalRevenue: 2748178.11,
    projectedRevenue: 907702.75,
    grossMargin: 0.70338765,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1880995.49,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2771612.8,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1933034.54,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 52039.05,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Sep"],
    totalRevenue: 2745465.68,
    projectedRevenue: 907702.75,
    grossMargin: 0.70935781,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 1642239.58,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2552559.64,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1947517.53,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 305277.95,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Oct"],
    totalRevenue: 2881951.94,
    projectedRevenue: 907702.75,
    grossMargin: 0.72657481,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 2058106.16,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 2930104.41,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 2093953.69,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 35847.53,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Nov"],
    totalRevenue: 1710754.94,
    projectedRevenue: 907702.75,
    grossMargin: 0.92829727,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: 231211.68,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: 353877.48,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: 1588089.14,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: 1356877.46,
    projectedEbitda: 123204.41666667,
  },
  {
    month: ["2024", "Dec"],
    totalRevenue: null,
    projectedRevenue: 907702.75,
    grossMargin: null,
    projectedGrossMargin: 0.5141473,
    salesAndMarketing: null,
    projectedSalesAndMarketing: 258488.5,
    totalExpenses: null,
    projectedTotalExpenses: 343488.5,
    preMarketingEbitda: null,
    projectedPreMarketingEbitda: 381692.91666667,
    ebitda: null,
    projectedEbitda: 123204.41666667,
  },
];

export default financialData;
